import { useEffect, useRef } from 'react';
import { useLoading } from '../contexts/LoadingContext';

export const useDataLoading = (componentId, isLoading, dependencies = []) => {
  const { registerLoading, unregisterLoading } = useLoading();
  const isRegistered = useRef(false);

  useEffect(() => {
    // Register loading state
    if (!isRegistered.current) {
      registerLoading(componentId, isLoading);
      isRegistered.current = true;
    } else {
      registerLoading(componentId, isLoading);
    }

    // Cleanup on unmount
    return () => {
      unregisterLoading(componentId);
      isRegistered.current = false;
    };
  }, [componentId, isLoading, registerLoading, unregisterLoading, ...dependencies]);

  // Cleanup on unmount
  useEffect(() => {
    return () => {
      unregisterLoading(componentId);
    };
  }, [componentId, unregisterLoading]);
};
